<template>
  <form
    :class="[
      'd-flex align-items-center justify-conntent-center position-relative',
      classes,
    ]"
  >
    <GuLabel
      class="d-flex align-items-center justify-content-center position-absolute ms-3 mb-0"
      for="search-form-input"
    >
      <i class="bx bx-search" aria-hidden="true" />
      <span class="visually-hidden">Search</span>
    </GuLabel>
    <GuInput
      id="search-form-input"
      v-model="model"
      type="search"
      :maxlength="maxLength"
      :class="['ps-8 hide-clear-icon', computedSize]"
      :placeholder="placeholder"
    />
    <GuTooltip v-if="model">
      <template #trigger>
        <GuButton
          icon="bx-x"
          size="sm"
          outline
          variant="light"
          class="position-absolute end-0 px-1 py-0 me-1 border-0"
          type="reset"
          aria-label="Clear the query"
          @click="clearForm"
        />
      </template>
      Clear
    </GuTooltip>
  </form>
</template>

<script setup>
import { computed } from 'vue'

import { GuButton } from '@shared/gu-components/button'
import { GuInput } from '@shared/gu-components/input'
import { GuLabel } from '@shared/gu-components/label'
import { GuTooltip } from '@shared/gu-components/tooltip'

const model = defineModel({ type: String })

const props = defineProps({
  classes: {
    type: String,
    required: false,
    default: '',
  },
  placeholder: {
    type: String,
    required: false,
    default: 'Filter',
  },
  size: {
    type: String,
    required: false,
    default: '',
  },
  maxLength: {
    type: Number,
    default: 250,
    description: 'Max length of the text',
  },
})

const emits = defineEmits(['clear'])

const clearForm = () => {
  model.value = ''
  emits('clear')
}

const computedSize = computed(() => {
  return props.size ? `form-control-${props.size}` : ''
})
</script>
